export interface OemSettings {
    oemCode: string;
    supportPhone: string;
    supportEmail: string;
}

export enum DealerConfigSettings {
    DealerSigningPreference = 1,
    NotifyCustomerOnQueueEntry = 2,
    NotifyDealerOnQueueEntry = 3,
    FeatureRouteOne = 4,
    DealVehiclePrice = 5,
}
